// extracted by mini-css-extract-plugin
export default {"container":"_Cjyl","imagesContainer":"jqQ9q","roundedImage":"Rch_W","textContainer":"iWL6l","title":"J0kvf","subtitle":"trkfR","link":"N1eVi"};